/* eslint-disable no-shadow */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useRef } from 'react';
import {
  Stack, IconButton, InputAdornment, TextField, Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { appSliceActions } from '../../appSlices/appSlice';
import axiosInstance from '../../utils/axiosInstance';
import Iconify from '../iconify';
import SingleSelector from '../single-selector/singleSelector';
import fetchDeviceList from '../../utils/fetchDeviceList';
import fetchStreamList from '../../utils/fetchStreamList';

export default function CameraCredentials() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [camera, setCamera] = useState(null);
  const cameraList = useSelector((state) => state.app.cameraList);
  const usernameRef = useRef();
  const [showPassword, setShowPassword] = useState(false);
  const passwordRef = useRef();

  const cameraCredentialsApi = () => {
    const jsonData = {
      username: usernameRef.current.value,
      password: passwordRef.current.value,
    };
    axiosInstance
      .post(`${window.location.protocol}//${camera.host}/api/v1/sensor/${camera.sensorId}/credentials`, jsonData)
      .then(async () => {
        enqueueSnackbar(`Success - camera credentials verified for ${camera.name}`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        const cameraList = await fetchDeviceList(camera.host);
        if (cameraList != null) {
          for (let i = 0; i < cameraList.length; i += 1) {
            cameraList[i].host = camera.host;
          }
          dispatch(appSliceActions.addDevice(cameraList));
        }
        const streamList = await fetchStreamList(camera.host);
        if (streamList != null) {
          for (let i = 0; i < streamList.length; i += 1) {
            streamList[i].host = camera.host;
          }
          dispatch(appSliceActions.addStream(streamList));
        }
      })
      .catch((error) => {
        if (error.response.data == null) {
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
      });
  };

  const handleSubmit = () => {
    enqueueSnackbar('Pending - verify camera credentials', {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    if (!camera) {
      enqueueSnackbar('Error - Please select camera', {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    if (!usernameRef.current.value || !passwordRef.current.value) {
      enqueueSnackbar('Error - Please enter username and password', {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    cameraCredentialsApi();
  };

  // Function to filter unauthorized cameras
  const filterUnauthorized = (cameraList) => cameraList
    .filter((camera) => camera.isAuthorized === false);

  return (
    <>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <SingleSelector
          id="verify-cameras"
          placeholder="Type to search"
          label="Select cameras"
          value={camera}
          onChange={setCamera}
          getOptionLabel={(option) => {
            if (option.remoteDeviceName && option.remoteDeviceLocation) {
              return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
            } if (option.remoteDeviceName) {
              return `${option.name} at ${option.remoteDeviceName}`;
            }
            return option.name;

          }}
          options={filterUnauthorized(cameraList)}
        />
        <TextField name="username" label="username" inputRef={usernameRef} />
        <TextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          inputRef={passwordRef}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        <LoadingButton size="large" type="submit" variant="contained" onClick={handleSubmit}>
          Submit
        </LoadingButton>
      </Box>
    </>
  );
}
